import AnalyticsGateway from '../lib/AnalyticsGateway';

export default function sendEditAgentBioAnalyticsEvent(agentIntro, agentNotes) {
  return (dispatch, getState) => {
    AnalyticsGateway.sendEvent({
      eventName: 'Edit Agent Bio',
      properties: [
        {label: 'Agent Name', value: agentIntro},
        {label: 'Agent Description', value: agentNotes},
      ],
    });
  };
}